import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { AccessService } from '@shared-lib/foundry-shared/access.service';
import { KeycloakInitService } from '../foundry-auth-services/keycloak-init.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private readonly access: AccessService,
    private readonly keycloakInit: KeycloakInitService,
  ) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      await this.access.login(state.url);
      return false;
    }

    await this.keycloakInit.loadAuthenticatedUserPermissions();
    return await this.access.canAccessRoute(state.url)
      ? true
      : this.router.parseUrl('/access-denied');
  }
}

@Injectable({ providedIn: 'root' })
export class DefaultRouteGuard {
  constructor(
    private readonly router: Router,
    private readonly access: AccessService,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (!this.access.isLoggedIn()) {
      await this.access.login('/');
      return false;
    }

    const firstAllowedRoute = await this.access.getFirstAllowedRoute();
    return this.router.parseUrl(firstAllowedRoute ?? '/access-denied');
  }
}
